<template>
  <div class="container-fluid">
    <user-form
      :loading="loading"
      :userData="user"
      :formErrors="formErrors"
      @userSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultUser from "../defaultUser";
import UserForm from "../partials/UserForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    UserForm,
  },

  mixins: [alertLeave],

  data() {
    const user = cloneDeep(defaultUser);
    const organizationId = this.$route.query.organization_id;
    const resellerId = this.$route.query.reseller_id;

    if (organizationId) {
      user.organization.id = organizationId;
    }
    if (resellerId) {
      user.reseller.id = resellerId;
    }
    return {
      user,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(user) {
      this.loading = true;
      const userData = cloneDeep(user);

      try {
        await this.$store.dispatch("users/add", userData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("USERS.USER_ADDED"),
        });
        const user = await this.$store.getters["users/user"];
        this.$emit("onViewUser", user, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
